import { ActivitiesService } from 'data/services/activities';
import { ActivitiesServiceInterface } from 'domain/services';
import { makeDeleteActivity } from 'main/factories/usecases/activity/remote-delete-activity-factory';
import { makeDeleteActivityValidation } from 'main/factories/usecases/activity/remote-delete-activity-validation-factory';
import { makeGetActivitiesInProgressCountGroupedByOrganization } from 'main/factories/usecases/activity/remote-get-activities-in-progress-count-grouped-by-organization-factory';
import { makeGetActivityById } from 'main/factories/usecases/activity/remote-get-activity-by-id-factory';

export const makeActivitiesService = (): ActivitiesServiceInterface => {
  return new ActivitiesService(
    makeGetActivitiesInProgressCountGroupedByOrganization(),
    makeGetActivityById(),
    makeDeleteActivity(),
    makeDeleteActivityValidation(),
  );
};
